import { Meric, Johnson, Generali, Quest, Harman, Adp, Audi, Bosch, Cgi, Ntuc, Ntt, Zurich } from "../images/index";

const globalBrands = [Meric, Johnson, Generali, Quest, Harman, Adp, Audi, Bosch, Cgi, Ntuc, Ntt, Zurich];

export { globalBrands };
